import {Component, OnInit} from '@angular/core';
import {Flats} from '../../../../shared/models/flats.model';
import {SmartTableConfigInterface} from '../../../../shared/interface';
import {MatDialog} from '@angular/material/dialog';

import {ActivatedRoute} from '@angular/router';
import {Flat} from '../../../../shared/models/flat.model';
import {FlatManagerService} from '../../../../shared/service/flat-manager.service';
import {FlatModalComponent} from '../../../../shared/modal/flat-modal/flat-modal.component';

@Component({
  selector: 'app-flat-manager-page',
  templateUrl: './flat-manager-page.component.html',
  styleUrls: ['./flat-manager-page.component.scss']
})
export class FlatManagerPageComponent implements OnInit {


  tableData: Flats;
  selectedRoom: Flat;
  smartTableConfig: SmartTableConfigInterface;


  constructor(public dialog: MatDialog, private flatManagerService: FlatManagerService, private activatedRoute: ActivatedRoute) {

    this.initSmartTable();
    this.flatManagerService.flats.subscribe((flats: Flats) => {
      this.tableData = flats;
    });

    this.flatManagerService.selectedFlat.subscribe((flat: Flat) => {
      this.selectedRoom = flat;
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(
      (data: { flatsResolve: any }) => {
        this.tableData.items = data.flatsResolve;
      }
    );
  }

  initSmartTable() {
    this.smartTableConfig = {
      columns: [
        {labelKey: 'FLAT.NAME', dataKey: 'name', isImage: false},
        {labelKey: 'FLAT.PRICE', dataKey: 'price', isImage: false},
      ],
      displayedColumns: ['name', 'price']
    };
  }


  openDialog(selectedFlatModel?: Flat) {

    const dialogRef = this.dialog.open(FlatModalComponent, {
      hasBackdrop: true,
      width: '60vw',
      data: selectedFlatModel ? selectedFlatModel : new Flat()
    });

  }


  deleteItem(event) {
    this.flatManagerService.deleteFlat(event.item, event.dialogRef);
  }

}
